import {
  WizardStep,
  WizardSteps,
  wizardSteps,
  TARGET_LOAN_CONFIG,
  TARGET_CLIENT_CHECKS,
} from '../constants/wizard'
import Routes from '../constants/routes'

export const areAllPreviousStepsCompleted = (
  steps: WizardSteps,
  actualStepName: string
): boolean => {
  let ret: boolean = true
  const actualStep = steps[actualStepName]

  if (!actualStep) {
    ret = false
  } else if (actualStep.prev) {
    let previousStepName: string = actualStep.prev()

    while (previousStepName) {
      const step: WizardStep = steps[previousStepName]
      if (!step.completed) {
        ret = false
        previousStepName = ''
      } else {
        previousStepName = step.prev ? step.prev() : ''
      }
    }
  }

  return ret
}

export const getReturnRoute = (target: number): string | undefined => {
  if (target >= TARGET_CLIENT_CHECKS) {
    return Routes.CLIENT_CHECKS
  } else if (target >= TARGET_LOAN_CONFIG) {
    return Routes.LOAN_CONFIGURATOR
  }
  const step = Object.values(wizardSteps).find(
    (step: WizardStep) => Array.isArray(step.cblCodes) && step.cblCodes.includes(target)
  )
  return step && step.next && wizardSteps[step.next()].route
}
